import React, {lazy, Suspense} from 'react';
import {render} from 'react-dom';
import {parseDatasetToProps} from "../../parseDatasetToProps";

/* Components */
const DatePicker = lazy(() => import(/* webpackChunkName: "DatePicker" */ './components/DatePicker'));

const datepickers = document.querySelectorAll('.datepicker');
datepickers.forEach((element) => {
    const props = parseDatasetToProps(element.dataset);

    render(
        <Suspense fallback={<></>}>
            <DatePicker {...props}/>
        </Suspense>,
        element
    );
});
